import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { SurveyLatestWaveProgressView } from 'src/app/models/survey.model';

@Component({
  selector: 'app-survey-wave-progress-dialog',
  templateUrl: './survey-wave-progress-dialog.component.html',
  styleUrl: './survey-wave-progress-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogTitle, MatDialogContent],
})
export class SurveyWaveProgressDialogComponent {
  protected readonly data = inject<SurveyLatestWaveProgressView>(MAT_DIALOG_DATA);
}
